export default __webpack_public_path__ + "static/images/plugin-push.png?8256cade4631869ad2ac02b68e613d4f";